import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function FormField({ id, label, error, children, half = true, stacked = false }) {
    const labelClassName = stacked ? 'control-label form-field__label--stacked' : 'col-md-6 control-label';
    const wrapper = (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: id, className: labelClassName, children: label }), _jsxs("div", { className: "field-input-wrapper", children: [_jsx("div", { className: "input-group", children: children }), _jsx("span", { className: "field-error", children: error || '\u00A0' })] })] }));
    if (half) {
        return _jsx("div", { className: stacked ? 'col-xs-6 form-field--stacked' : 'col-xs-6', children: wrapper });
    }
    return _jsx("div", { children: wrapper });
}
